import Glide from '@glidejs/glide';
import { Autoplay } from '@glidejs/glide/dist/glide.modular.esm';
import '@glidejs/glide/dist/css/glide.core.min.css';

document.addEventListener('DOMContentLoaded', () => {
    const slider = document.querySelector('.glide.testimonials');
    if (!slider) return;

    const glide = new Glide(slider, {
        type: 'carousel',
        startAt: 0,
        perView: 2,
        gap: 32,
        animationDuration: 600,
        autoplay: 6000,
        hoverpause: true,
        breakpoints: {
            1023: {
                perView: 1
            }
        }
    });

    glide.mount({ Autoplay });

    // S'assurer que l'autoplay démarre
    setTimeout(() => {
        if (glide.settings.autoplay && typeof glide.play === 'function') {
            glide.play();
        }
    }, 100);
});
